import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function Loading(props) {
  const {loading, small, children, className, ...rest} = props;

  return (
    <>
      {loading ? (
        <div className={classnames('react-loading-container', small ? 'small' : undefined, className)} {...rest}>
          <span className="react-loading fas fa-spinner" />
        </div>
      ) : (
        children
      )}
    </>
  );
}

Loading.defaultProps = {
  loading: false,
  small: false,
};

Loading.propTypes = {
  /** Whether or not the loading indicator should be shown. */
  loading: PropTypes.bool,
  /** Set to true to show a smaller loading indicator. When not small, it will be full viewport height. */
  small: PropTypes.bool,
  /** Content to display when not loading. */
  children: PropTypes.node.isRequired,
  /** Class name for the element. */
  className: PropTypes.string,
};
